module.exports = __webpack_public_path__ + "static/media/Discovery_Kids_Museum_undersea_mural_in_progress_Huntersville_NC_2012.d61673a7.webp";